// Campus photo for /colleges/spelman-college: CC0 1.0, by Thomson200, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASpelman_College_gates.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/spelman-college/; credited under the photo.
const photo = {
    "slug": "spelman-college",
    "alt": "Brick gates and a low brick wall lined with trees at the entrance to Spelman College in Atlanta, Georgia",
    "src": "/colleges/spelman-college/campus-1600.webp",
    "srcSmall": "/colleges/spelman-college/campus-800.webp",
    "srcMid": "/colleges/spelman-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/spelman-college/og.jpg",
    "title": "Spelman College gates",
    "author": "Thomson200",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASpelman_College_gates.jpg",
    "read": "2026-10-01"
};

export default photo;
